module.exports = __webpack_public_path__ + "static/media/ser_han_dig.b4dfa745.png";